import { ReactNode } from 'react';
import { CardTemplate } from '@shared/scenes/cards/types';
import { CardTemplateContext } from './context';

interface Props {
  template: CardTemplate;
  children: ReactNode;
}

export function MBCardTemplateProvider({ template, children }: Props) {
  return (
    <CardTemplateContext.Provider value={{ template }}>{children}</CardTemplateContext.Provider>
  );
}
